import { useCallback } from "react";
import { Resource } from "../../../components/loader/resource";
import { Amount } from "../../../components/widget/text-widget";
import { usePariticipationSummary } from "../../../store/participations/queries";
import { ParticipationsDTO } from "../../../store/participations/models/dto";
import { ParticipationsRoutes } from "../../participations/routes";
import { StyledTextWidget } from "./common";

export const ParticipatedInTile = () => (
  <Resource r={usePariticipationSummary()}>
    {useCallback(
      (data: ParticipationsDTO.Responses.GetParticipationSummary.T) => (
        <StyledTextWidget
          title="Onboarded Projects:"
          to={ParticipationsRoutes.names.ownAll}
        >
          <Amount>{data.totalFromBeginningOfTime}</Amount> checks
        </StyledTextWidget>
      ),
      []
    )}
  </Resource>
);
